import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';
import { DrawerContainer } from '../Drawer/DrawerContainer';

@Component
export class QuickBuyButton extends ThemeComponent {
    @Prop({default: null}) freeGifts!: [];

    @Ref({required: false}) qiuckAddCta!: HTMLButtonElement;

    private drawerContainer: DrawerContainer|null = null;

    init() {
        // Set the drawer container
        this.drawerContainer = document.querySelector('.side-cart-drawer');

        if (this.qiuckAddCta) {
            this.$listen(this.qiuckAddCta, 'click', async() => {

                const variantID = Number(this.qiuckAddCta.getAttribute('variant-id'));

                await this.setEventListeners(variantID);
                this.drawerContainer?.open();
            });
        }



    }

    async setEventListeners(variantID: number) {
        const productItem = {
            id: variantID,
            quantity: 1,
            properties: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                _display_quantity: 1
            }
        };

        if (!this.freeGifts) {

            await cart.asInteraction(async() => {
                await cart.addItem(productItem).catch((event: unknown | null) => {
                    if (event instanceof Error) {
                        this.$log.error('error', event.message);
                    }
                });
            });

        } else {

            const giftIds = [];

            for(const freeGiftId of this.freeGifts) {
                giftIds.push({
                    id: freeGiftId,
                    quantity: 1,
                    properties: {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        _eligibleProductId: String(variantID)
                    }
                });
            }

            const productWithGifts = [productItem, ...giftIds];

            await cart.asInteraction(async() => {
                await cart.addItems(productWithGifts).catch((event: unknown | null) => {
                    if (event instanceof Error) {
                        this.$log.error('error', event.message);
                    }
                });
            });
        }
    }
}
